import { cn } from "../../utils/style";

interface MobileOverlayProps {
  onClose: () => void;
  className?: string;
}

export const MobileOverlay = ({ onClose, className }: MobileOverlayProps) => {
  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 top-0 z-50 bg-muted-darker/90",
        className,
      )}
      onClick={onClose}
    />
  );
};
